module.exports = __webpack_public_path__ + "img/ic-diagram.cf7f3c5d.svg";